module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-5ddfb8f8c77ab252611920557495b15e.jpg";